import styled from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { breakpoints } from '@/config/layout'

const StItemContainer = styled.div<{ isToday: boolean }>`
  ${({ theme, isToday }) => `
    position: relative;

    ${
      isToday
        ? `
          background-color: ${theme.Colors.Background.White};
          margin: 0 -${theme.UI.SpacingPx.Space6};
          padding: 0 ${theme.UI.SpacingPx.Space6};
        `
        : null
    };

    @media ${breakpoints.s} {
      gap: 0;
      background-color: transparent;
    }
  `}
`

const StActivitiesContainer = styled(FlexColumn)`
  ${({ theme }) => `
    flex-grow: 1;
    min-width: 0;
    gap: ${theme.UI.SpacingPx.Space2}
  `}
`

const StDateContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    align-items: center;
    width: ${theme.UI.SpacingPx.Space6};
    margin-right: ${theme.UI.SpacingPx.Space4};

    @media ${breakpoints.s} {
      margin-right: 0;
      align-items: flex-start;
      flex-direction: row-reverse;
      justify-content: space-between;
      width: 130px;
    }
  `}
`

const StDate = styled(FlexColumn)`
  @media ${breakpoints.s} {
    flex-direction: column-reverse !important;
    align-items: center;
    width: 110px;
  }
`
const StDotLineContainer = styled(FlexColumn)`
  @media ${breakpoints.s} {
    margin-top: 4px;
  }
`

const StDot = styled.div`
  ${({ color }) => `
    width: 8px;
    height: 8px;
    min-height: 8px;
    border-radius: 50%;
    background-color: ${color};
  `}
`

export { StActivitiesContainer, StDate, StDateContainer, StDot, StDotLineContainer, StItemContainer }
